export const featureCards = [
  {
    icon: 'ri-database-2-line',
    title: 'Organized Product Database',
    description: 'Browse through carefully categorized Sugargoo products across shoes, clothing, accessories and more. Every item is organized for quick discovery.',
  },
  {
    icon: 'ri-guide-line',
    title: 'Complete Shopping Guides',
    description: 'Learn how to navigate Sugargoo like a pro with our detailed guides covering everything from product selection to international shipping.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Shipping Information',
    description: 'Understand international shipping costs, delivery times, and the best shipping methods for your Sugargoo purchases.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Resources',
    description: 'All our spreadsheet resources are regularly updated with the latest products, ensuring you always have access to fresh finds.',
  },
  {
    icon: 'ri-coupon-line',
    title: 'Discount & Coupon Info',
    description: 'Stay informed about available Sugargoo discount codes and money-saving tips for your international shopping.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description: 'New to Sugargoo? Our resources are designed to help beginners understand the platform and start shopping with confidence.',
  },
];

export const comparisonData = [
  { feature: 'Finding Products', traditional: 'Slow manual search', spreadsheet: 'Fast organized browsing' },
  { feature: 'Product Organization', traditional: 'Scattered listings', spreadsheet: 'Well-categorized structure' },
  { feature: 'Category Filtering', traditional: 'Limited options', spreadsheet: 'Easy one-click access' },
  { feature: 'Beginner Experience', traditional: 'Overwhelming', spreadsheet: 'Clear and guided' },
  { feature: 'Time to Find Items', traditional: 'Hours of browsing', spreadsheet: 'Minutes with categories' },
  { feature: 'Update Frequency', traditional: 'Unknown', spreadsheet: 'Regularly maintained' },
];

export const trustItems = [
  { icon: 'ri-check-double-line', text: 'Structured and organized product information' },
  { icon: 'ri-compass-3-line', text: 'Easy navigation with intuitive category system' },
  { icon: 'ri-refresh-line', text: 'Regularly updated resources and product lists' },
  { icon: 'ri-book-open-line', text: 'Educational guides for all experience levels' },
  { icon: 'ri-global-line', text: 'International shipping insights and cost breakdowns' },
  { icon: 'ri-shield-star-line', text: 'Transparent and trustworthy information sources' },
];